/**
 * Created by yqdong on 2018/3/18.
 * qq: 1013501639
 * @author yqdong
 *
 */
import { actions, apis } from '../constants'
import Store from '../Store'

export default function (ajax) {
  let store = new Store({
    state: {},
    actions: {
      [actions.notice.queryById] (context, data) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.notice.queryNoticeById,
            method: 'post',
            data
          })
          .then(res => {
            resolve(res)
          })
          .catch(reject)
        })
      },
      [actions.notice.query] (context, data) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.notice.queryNotice,
            method: 'post',
            data
          })
          .then(resolve)
          .catch(reject)
        })
      }
    }
  })
  return store
}
